export default __webpack_public_path__ + "static/media/js-basic.06bbb318.png";